import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Suspense as _Suspense, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dashboard-shell"
}
const _hoisted_2 = {
  class: "main-content border-radius-lg",
  id: "main"
}
const _hoisted_3 = { class: "content-scroll" }

import { onMounted, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import SideBar from '@/components/SideBar.vue'
import NavBar from '@/components/NavBar.vue'
import { usePlacesStore } from '@/services/stores/PlacesStore'
import { useClientsStore } from '@/services/stores/ClientsStore'
import { useDriversStore } from '@/services/stores/DriversStore'
import { useServicesStore } from '@/services/stores/ServiceStore'
import { useWpClientsStore } from '@/services/stores/WpClientStore'
import { useSettingsStore } from "@/services/stores/SettingsStore";
import { useMetricsStore } from "@/services/stores/MetricsStore";
import { useLoadingState } from "@/services/stores/LoadingState";


export default /*@__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props) {

const coreLoaded = ref(false)

const placesStore = usePlacesStore()
const clientsStore = useClientsStore()
const driverStore = useDriversStore()
const servicesStore = useServicesStore()
const { getDrivers } = driverStore
const { drivers } = storeToRefs(driverStore)
const { getHistoryServices, getPendingServices, getInProgressServices, rehydrateServiceDrivers } = servicesStore
const { getWpClients } = useWpClientsStore()
const settingsStore = useSettingsStore()
const { getBranches, getRideFees } = settingsStore
const { branchSelected } = storeToRefs(settingsStore)
const { getCurrentYearMetric } = useMetricsStore()
const { setLoading } = useLoadingState()

const startHeavyHydration = (): void => {
  clientsStore.hydrateClientsInBackground().catch(() => undefined)
  placesStore.hydratePlacesInBackground(branchSelected.value?.city?.id).catch(() => undefined)
}

const loadAllData = async () => {
  setLoading(true)
  await getDrivers().catch(() => undefined)
  rehydrateServiceDrivers()

  await Promise.allSettled([
    getHistoryServices(),
    getPendingServices(),
    getInProgressServices(),
    getWpClients(),
    getBranches(),
    getRideFees(),
    getCurrentYearMetric(),
  ])

  coreLoaded.value = true
  setLoading(false)
  startHeavyHydration()
}

watch(drivers, () => {
  rehydrateServiceDrivers()
}, { deep: true })

watch(branchSelected, (selectedBranch, previousBranch) => {
  if (!coreLoaded.value) {
    return
  }

  if (selectedBranch?.city?.id === previousBranch?.city?.id) {
    return
  }

  placesStore.hydratePlacesInBackground(selectedBranch?.city?.id).catch(() => undefined)
}, { deep: true })

onMounted(async () => {
  await loadAllData()
  require('@/vendor/js/soft-ui-dashboard')
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        (coreLoaded.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(SideBar),
              _createElementVNode("main", _hoisted_2, [
                _createVNode(NavBar),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_router_view)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }))
  ]))
}
}

})